import * as React from 'react';
import { useSelector } from 'react-redux';
import { useProtocolIFrame } from 'pages/views/devices/hooks/use-protocol-iframe';
import { PageLayout } from './PageLayout';
import { DevicesPage } from './DevicesPage';
import { InstallationPage } from './InstallationPage';

const Devices = () => {
  const hasStartedHubDownload = useSelector<any, string>(state => state.hub.hasStartedHubDownload);
  useProtocolIFrame();

  React.useEffect(() => {
    window.merchantos.asyncSubscribe.notifySubscribers('react.mount.topbar', {
      props: {
        crumbs: !window.isGriffin()
          ? [
              {
                text: 'Devices',
                name: 'devices',
              },
            ]
          : [
              {
                text: 'Customer Facing Display',
              },
            ],
      },
    });
  }, []);

  return (
    <PageLayout>
      {hasStartedHubDownload && !window.isGriffin() ? <InstallationPage /> : <DevicesPage />}
    </PageLayout>
  );
};

export default Devices;
